import vars from '@/config/vars';
import routes from '@/routes';

/**
 * get base url
 * @param {string} val
 * @returns {string}
 */
const getBaseurl = (val = '') => `${vars.request.baseUrl}/${val}`;

/**
 * add parameters to path
 * @param {string} route
 * @param {object} params
 * @returns path with parameters
 */
const routeWithParams = (route = '', params = {}) => {
  let output = route;

  Object.keys(params).forEach((key) => {
    output = output.replace(`:${key}`, params[key]);
  });

  return output;
};

/**
 * Retrieves a route object by its ID from a specific group in the routes configuration.
 * @param {string} groupKey - The key of the group to search in (e.g., 'newProposal').
 * @param {string} routeId - The ID of the route to find (e.g., 'details').
 * @returns {object|null} - The route object if found, otherwise null.
 */
const getRouteById = (groupKey = '', routeId = '') => {
  const group = routes[groupKey];

  if (!group || !group.pages) {
    return null;
  }

  return group.pages.find((page) => page.id === routeId) || null;
};

/**
 * Retrieves the previous and next elements in an array based on the given ID.
 *
 * @param {string|number} id - The ID of the current element to find in the array.
 * @param {array} - The array of objects to search through.
 * @returns {{ previous: Object|null, next: Object|null }} - object
 */
const getPreviousAndNextRoutes = (id, arr = []) => {
  const index = arr.findIndex((element) => element.id === id);

  // handle edge cases
  if (index < 0 || index >= arr.length) {
    return { previous: null, next: null };
  }

  const previous = index > 0 ? arr[index - 1] : null;
  const next = index < arr.length - 1 ? arr[index + 1] : null;

  return { previous, next };
};

export {
  getBaseurl,
  routeWithParams,
  getRouteById,
  getPreviousAndNextRoutes,
};
